import Component from '@cell/cell-core/component/component';
import './toast.scss';

const DURATION_TO_SHOW = 5000;

class Toast extends Component {
  constructor() {
    super();

    this.timeout = -1;

    this.elements = {
      text: this.querySelector('.Text'),
    };

    this.handleToastShowEvent = this.handleToastShowEvent.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.close', this.handleCloseClick);
    globalThis.on('share-button.copied-url', this.handleToastShowEvent);
  }

  handleToastShowEvent({ data }) {
    // Don't show Toast again if it's already visible.
    if (this.timeout !== -1) return;

    this.setMessage(data.message);

    this.show();

    this.timeout = setTimeout(() => {
      this.hide();

      clearTimeout(this.timeout);

      this.timeout = -1;
    }, DURATION_TO_SHOW);
  }

  handleCloseClick() {
    this.hide();

    clearTimeout(this.timeout);

    this.timeout = -1;
  }

  show() {
    this.classList.add('Toast--Active');
  }

  hide() {
    this.classList.remove('Toast--Active');
  }

  setMessage(message) {
    this.elements.text.textContent = message;
  }
}

customElements.define('c-toast', Toast);
